<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
       <!--router-link class="d-none d-sm-inline-block btn btn-danger shadow-sm" :to="{ name: 'service'}">
        <i class="fa fa-thumb-tack fa-sm text-white-50"></i>
        Voir les commandes du jour
      </router-link--> 
    </div>
    <div class="row"  v-if="apiRslt.fetch.success">
      <div class="col-xl-3 col-md-6 mb-4">
        <card-stat
            :progressBar="false"
            classe="info"
            title="Ventes"
            icon="fa-money"
            :value="statOrder.global.monthly_sales_amount + '€'"
            prefix="de ventes"
        />
      </div>
      <div class="col-xl-3 col-md-6 mb-4">
        <card-stat
            :progressBar="false"
            classe="success"
            title="Transactions"
            icon="fa-exchange"
            :value="statOrder.global.monthly_ordered"
            prefix="finalisées"
        />
      </div>
      <div class="col-xl-3 col-md-6 mb-4">
        <card-stat
            :progressBar="false"
            classe="warning"
            title="Temps de préparation"
            icon="fa-hourglass-end"
            :value="statOrder.global.order_time"
            prefix="minutes / commandes"
        />
      </div>
      <div class="col-xl-3 col-md-6 mb-4">
        <card-stat
            style="cursor: pointer" @click="$router.push({ name: 'service'})"
            :progressBar="false"
            classe="danger"
            title="Commandes"
            icon="fa-thumb-tack"
            :value="statOrder.global.order_on_wating"
            prefix="à préparer"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-xl-8 col-lg-8 col-md-12">
        <dash-block title="Evolution des ventes">
          <template #body>
            <Bar
                v-if="apiRslt.fetch.success"
                :chart-options="chartOptions"
                :chart-data="statOrder.global.sales_evolution"
                chart-id="bar-chart"
                dataset-id-key="label"
                :width="400"
                :height="300"
            />
          </template>
        </dash-block>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12">
        <dash-block title="Preparation commandes (min)">
          <template #body>
            <Doughnut
                v-if="apiRslt.fetch.success"
                :chart-options="chartOptions"
                :chart-data="statOrder.timespend"
                chart-id="bar-chart"
                dataset-id-key="label"
                :width="400"
                :height="250"
            />
          </template>
        </dash-block>
      </div>
<!--@todo later      <div class="col-xl-4 col-lg-4 col-md-12">
        <dash-block title="Incidents">
          <template #body>
            ContactBox
          </template>
        </dash-block>
      </div>
      <div class="col-xl-8 col-lg-8 col-md-12">
        <dash-block title="Contact" body-height="30rem">
          <template #body>
            <contact-box/>
          </template>
        </dash-block>
      </div>-->
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import DashBlock from "@/modules/home/components/DashBlock";
import CardStat from "@/modules/home/components/CardStat";
import { Bar, Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)


export default {
  name: "Home",
  components:{
    DashBlock,
    CardStat,
    Bar,
    Doughnut
  },
  created() {
    this.loadOrdersStatistics()
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed:{
    ...mapState('statistics',['statOrder']),
    ...mapState('statistics',['apiRslt'])
  },
  methods:{
    ...mapActions('statistics',['loadOrdersStatistics'])
  }
}
</script>

<style scoped>

</style>
